import { FaLocationDot } from "react-icons/fa6";
import { IoCall, IoMail } from "react-icons/io5";

export default function Footer() {
  return (
    <div className="bg-gray-900 text-white p-8 md:p-16 mt-5">
      <div className="flex flex-col md:flex-row justify-between gap-10">
        {/* Left Section */}
        <div className="flex flex-col md:flex-row gap-10 w-full md:w-1/2">
          {/* Useful Links */}
          <div className="space-y-6 w-full md:w-1/2">
            <p className="text-2xl font-bold">Useful Links</p>
            <ol className="space-y-2 cursor-pointer font-normal text-lg text-zinc-400">
              {[
                "About Company",
                "Services",
                "How It Works",
                "Our Blog",
                "Contact Us",
              ].map((link, index) => (
                <li key={index} className="hover:text-red-500">
                  {link}
                </li>
              ))}
            </ol>
          </div>

          {/* Links */}
          <div className="space-y-6 w-full md:w-1/2">
            <p className="text-2xl font-bold">Links</p>
            <ol className="space-y-2 cursor-pointer font-normal text-lg text-zinc-400">
              {[
                "House Sanitizing",
                "Window Sanitizing",
                "Domestic Sanitizing",
                "Disinfection",
                "Office Sanitizing",
              ].map((link, index) => (
                <li key={index} className="hover:text-red-500">
                  {link}
                </li>
              ))}
            </ol>
          </div>
        </div>

        {/* Right Section - Head Office */}
        <div className="w-full md:w-1/3">
          <p className="text-2xl font-bold">HEAD OFFICE</p>
          <div className="space-y-4 text-zinc-400 mt-4">
            <div className="flex gap-4">
              <FaLocationDot className="mt-1" />
              <p>
                #184, Sri Sai Maruthi Building, 2nd Cross, <br /> Nelamangala
                New Town, Bangalore-562123
              </p>
            </div>
            <div className="flex gap-4">
              <IoCall className="mt-1" />
              <p className="hover:text-red-500 cursor-pointer">
                +91 98446 36155 / 9845988061
              </p>
            </div>
            <div className="flex gap-4">
              <IoMail className="mt-1" />
              <p className="hover:text-red-500 cursor-pointer">
                saisuchithpest@gmail.com
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Branches Section */}
      <div className="mt-16">
        <h1 className="text-2xl font-bold text-center mb-10">BRANCHES</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
          {[
            {
              city: "Mysuru",
              address:
                "#1032, 32nd Cross, 4th Main, Vidyaranyapuram, Mysuru - 570 008.",
              phone: "+91 90350 27813",
              email: "saisuchithmys@gmail.com",
            },
            {
              city: "Mangaluru",
              address:
                "#N-2/132/1, Durgaprasad Building, Kottara, Mangaluru, D.K. Dist.",
              phone: "+91 99455 54709",
              email: "suchithpest5@gmail.com",
    
  
            },
            {
              city: "Hubballi",
              address: "#235, Akshay Carden, Vidya Nagar, Hubballi- 580031.",
              phone: "+91 90350 27821",
              email: "saisuchithpesthbl@gmail.com",
            },
          ].map((branch, index) => (
            <div key={index} className="space-y-4">
              <h1 className="text-xl font-bold">{branch.city}</h1>
              <div className="space-y-2 text-zinc-400">
                <div className="flex gap-4">
                  <FaLocationDot className="mt-1" />
                  <p>{branch.address}</p>
                </div>
                <div className="flex gap-4">
                  <IoCall className="mt-1" />
                  <p className="hover:text-red-500 cursor-pointer">
                    {branch.phone}
                  </p>
                </div>
                <div className="flex gap-4">
                  <IoMail className="mt-1" />
                  <div className="hover:text-red-500 cursor-pointer">
                {Array.isArray(branch.email) ? (
                  branch.email.map((mail, idx) => (
                    <p key={idx}>{mail}</p>
                  ))
                ) : (
                  <p>{branch.email}</p>
                )}
              </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Footer */}
      {/* Bottom Footer */}
      <div className="bg-gray-950 flex flex-row items-center justify-center md:justify-between- px-4 md:px-10 py-6 mt-16 w-full flex-wrap gap-4">
        <img src={require("./SSPC.jpg")} alt="logo" className="h-16" />
        <p className="font-normal text-lg text-zinc-400 text-center md:text-left">
          <span className="text-red-500 cursor-pointer">SSPC</span> &#169; 2025
          All Rights Reserved
        </p>
      </div>
    </div>
  );
}
